import { FormlyFieldConfig } from '@ngx-formly/core';

export function minValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `This value must be greater than ${field.props?.min}`;
}
